import { useEffect, useState, useCallback } from 'react';
import Carousel from 'react-multi-carousel';
import Skeleton from '../../common/skeleton';
import RequestTypeFilterButton from './RequestTypeFilterButton';

import EnrollmentList from './EnrollmentList';
import './EnrollmentRequests.scss';
import SearchResultsFilterBar from './SearchResultsFilterBar';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { toast } from 'react-toastify';
import ToastMessage from '../../common/ToastMessage/index';
import debounce from 'lodash.debounce';

//const responsive = {
//desktop: {
//breakpoint: { max: 3000, min: 1250 },
//items: 7,
//},
//desktop1: {
//breakpoint: { max: 1250, min: 1024 },
//items: 4,
//},
//desktop2: {
//breakpoint: { max: 1024, min: 900 },
//items: 4,
//},
//desktop3: {
//breakpoint: { max: 900, min: 800 },
//items: 3,
//},
//desktop4: {
//breakpoint: { max: 800, min: 576 },
//items: 3,
//},
//mobile: {
//breakpoint: { max: 576, min: 0 },
//items: 2,
//},
//};

//const uniqueRequestTypes = [
//{
//label: 'ALL REQUESTS',
//value: 'allrequest',
//},
//{
//label: 'PENDING REQUESTS',
//value: 'Pending',
//},
//{
//label: 'APPROVED REQUESTS',
//value: 'Approved',
//},
//{
//label: 'DENIED REQUESTS',
//value: 'Denied',
//},
//];

const Enrollment = ({ selectedTabLocal }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1250 },
      items: 7,
    },
    desktop1: {
      breakpoint: { max: 1250, min: 1024 },
      items: 4,
    },
    desktop2: {
      breakpoint: { max: 1024, min: 900 },
      items: 4,
    },
    desktop3: {
      breakpoint: { max: 900, min: 800 },
      items: 3,
    },
    desktop4: {
      breakpoint: { max: 800, min: 576 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 2,
    },
  };

  const uniqueRequestTypes = [
    {
      label: 'ALL REQUESTS',
      value: 'allrequest',
    },
    {
      label: 'PENDING REQUESTS',
      value: 'Pending',
    },
    {
      label: 'APPROVED REQUESTS',
      value: 'Approved',
    },
    {
      label: 'DENIED REQUESTS',
      value: 'Denied',
    },
  ];

  console.log('selectedTabLocal@', selectedTabLocal);
  const [requestList, setRequestList] = useState([]);
  const [dataFetching, setDataFetching] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);

  //pagination specific states
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  //search
  const [searchText, setSearchText] = useState('');
  const [search, setSearch] = useState('');

  const [activeStatusFilter, setActiveStatusFilter] = useState('allrequest');
  const [affiliationData, setAffiliationData] = useState([]);
  const [requestType, setRequestType] = useState([]);

  const [sorted, setSorted] = useState('desc');
  const [sortCategory, setSortCategory] = useState('createddate');

  const handleTypeFilterClick = (value) => {
    console.log('handleTypeFilterClick', value);
    resetFilterSection();
    setActiveStatusFilter(value);
  };

  useEffect(() => {
    if (selectedTabLocal === 'enrollment') {
      fetchRequestsList();
    }
  }, [search, activeStatusFilter, pageSize, currentPage, selectedTabLocal]);

  const debouncedCall = useCallback(
    debounce((currentVal) => setSearch(currentVal), 500),
    [],
  );

  const onSearch = useCallback((event) => {
    setCurrentPage(1);
    setSearchText(event.target.value);
    debouncedCall(event.target.value);
  }, []);

  const resetFilterSection = useCallback(() => {
    setCurrentPage(1);
    setPageSize(10);
    setSearchText('');
    setSearch('');
    setRequestType([]);
  }, []);

  const serverSideSorting = useCallback((id, d) => {
    if (d !== undefined && id !== undefined) {
      setSorted(d);
      setSortCategory(id);
    }
  }, []);

  //fetch requests list
  const fetchRequestsList = async () => {
    setDataFetching(true);
    setIsAPIFailed(false);
    setRequestList([]);

    try {
      const getStatus = activeStatusFilter
        ? activeStatusFilter !== 'allrequest'
          ? `/status/${activeStatusFilter}`
          : ''
        : '';
      const responseList = await axiosInstance.get(
        APIEndpoints.getEnrollmentRequestsListAPI() +
          getStatus +
          `/pagenumber/${currentPage}` +
          `/pagesize/${pageSize}` +
          `${
            searchText && searchText !== '' ? `/searchkey/${searchText}` : ''
          }`,
      );
      const response = responseList?.data?.Response?.workListMasterDTOList;
      setTotalRecords(responseList?.data?.Response?.Pagination?.TotalRecords);
      //setRequestList(response);
      setRequestList(
        selectedTabLocal !== 'memberRegistration' ? response : response,
      );
      setDataFetching(false);
      setIsAPIFailed(false);
    } catch (error) {
      setDataFetching(false);

      if (error.response.status === 404) {
        setRequestList([]);
      } else {
        setIsAPIFailed(true);
      }
    }
  };

  return (
    <div className="approval-enrollment-container approval-enrollment-container-list">
      <div className="container-offset">
        <div className="carousel-container p-0">
          <div className="carousel-wrapper">
            <div className="d-flex each-claim-type-filter">
              {
                <Carousel
                  additionalTransfrom={0}
                  arrows
                  shouldResetAutoplay={false}
                  centerMode={false}
                  className=""
                  containerClass="container-with-dots pt-0"
                  dotListClass=""
                  draggable
                  focusOnSelect={false}
                  infinite={false}
                  keyBoardControl
                  minimumTouchDrag={80}
                  renderButtonGroupOutside={false}
                  renderDotsOutside={false}
                  itemClass={'slider-image-item each-claim-type'}
                  responsive={responsive}
                >
                  {!dataFetching
                    ? uniqueRequestTypes.map((eachType, index) => {
                        return (
                          <RequestTypeFilterButton
                            key={`each-claim-${eachType.value}`}
                            label={eachType.label}
                            isActive={eachType.value === activeStatusFilter}
                            clickHanler={() => {
                              handleTypeFilterClick(eachType.value);
                            }}
                          />
                        );
                      })
                    : [1, 2, 3, 4, 5].map((item) => (
                        <Skeleton key={item} width={120} height={25} />
                      ))}
                </Carousel>
              }
            </div>
          </div>
        </div>
      </div>
      {/*Carousal finish */}

      <SearchResultsFilterBar
        searchText={searchText}
        onSearch={onSearch}
        search={search}
        selectedTabLocal={selectedTabLocal}
        setAffiliationData={setAffiliationData}
        setTotalRecords={setTotalRecords}
        currentPage={currentPage}
        pageSize={pageSize}
        setIsAPIFailed={setIsAPIFailed}
        activeStatusFilter={activeStatusFilter}
        resetFilterSection={resetFilterSection}
        requestType={requestType}
        setRequestType={setRequestType}
        sorted={sorted}
        sortCategory={sortCategory}
        setDataFetching={setDataFetching}
        dataFetching={dataFetching}
        isNotFound={isNotFound}
        setIsNotFound={setIsNotFound}
      />
      {/*Filter finish */}

      <>
        <EnrollmentList
          activeStatusFilter={activeStatusFilter}
          pageSize={pageSize}
          setPageSize={setPageSize}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          //data={requestList}
          data={
            selectedTabLocal === 'affiliation'
              ? affiliationData
              : selectedTabLocal !== 'memberRegistration'
              ? requestList
              : []
          }
          totalRecords={totalRecords}
          dataFetching={dataFetching}
          isAPIFailed={isAPIFailed}
          isNotFound={isNotFound}
          selectedTabLocal={selectedTabLocal}
          sortingParams={{ sortBy: sortCategory, direction: sorted }}
          serverSideSorting={serverSideSorting}
        />
      </>
    </div>
  );
};

export default Enrollment;
